import React, { useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Grid from '@mui/material/Grid';
import ShipmentActions from '#component/shipment/overview/actions';
import { formatter } from '#component/shipment/helper';
import AlertStatus from '#component/shipment/dashboard/alert-status';
import { getIconProps as getExcursionIconProps } from '#component/shipment/dashboard/alert-status/alert-status';
import {
  ShipmentLabelCnt,
  ShipmentLabel,
  ShipmentLabelTooltip,
  ShipmentProjectLabel,
  DeviceNameCnt,
  ShipmentUID,
  SettingsCnt
} from '#component/shipment/overview/style';
import { shipmentEventType } from '#type';

function Header(props) {
  const {
    shipment,
    eventStatus,
    shipmentDateRange,
    account,
    rangeStart,
    rangeEnd,
    children,
    project,
    isMetricsLoaded
  } = props;

  const dispatch = useDispatch();

  const allEvents = useSelector(s => s.shipment?.allEvents || [], shallowEqual);

  const isEventsloading = eventStatus !== 'succeeded' || eventStatus === 'idle';

  const alertLogs = useMemo(() =>
    allEvents.filter(event => event.event?.id === shipmentEventType.TRIGGER_ALERT), [allEvents]);

  const alertMsg = useMemo(() =>
    getExcursionIconProps(alertLogs, account).message, [alertLogs, account]);

  const formattedUid = useMemo(() => formatter(shipment.uid), [shipment.uid]);

  const alertStatusComponent = useMemo(() => {
    if (isEventsloading) {
      return null;
    }

    return (
      <AlertStatus
        logs={alertLogs}
        isMobile={true}
      />
    );
  }, [isEventsloading, alertLogs]);

  return (
    <Grid container spacing={2} id="overviewHeader">
      <Grid item xs={12} md={12}>
        <ShipmentLabelCnt
          variant="overline"
          gutterBottom
        >
          {shipment.label && (
          <ShipmentLabelTooltip
            placement="bottom-start"
            title={shipment.label}
          >
            <ShipmentLabel>
              {shipment.label}
            </ShipmentLabel>
          </ShipmentLabelTooltip>)}
          {shipmentDateRange}
          {project && <ShipmentProjectLabel>{`Project: ${project.title}`}</ShipmentProjectLabel>}
        </ShipmentLabelCnt>
        <DeviceNameCnt>
          <ShipmentActions
            account={account}
            shipment={shipment}
            dispatch={dispatch}
            dateRange={[
              rangeStart,
              rangeEnd
            ]}
            alertStatusComponent={alertStatusComponent}
            tooltip={`${formattedUid} - ${alertMsg}`}
            isMetricsLoaded={isMetricsLoaded}
          >
            <ShipmentUID
              variant="h5"
              gutterBottom
            >
              {formattedUid}
            </ShipmentUID>
          </ShipmentActions>
        </DeviceNameCnt>
      </Grid>
      <Grid item xs={12}>
        <SettingsCnt>
          {children}
        </SettingsCnt>
      </Grid>
    </Grid>
  );
}

export default Header;
